import { HStack, Icon, Text, useBreakpointValue } from '@chakra-ui/react';
import { NavItem, NavItemProps } from '@saas-ui/react';

import { Link } from '@/components/common';
import { useActivePath } from '@/hooks/useActivePath';

interface AppSidebarlink extends NavItemProps {
  href: string;
  label: string;
  navIcon: React.ElementType;
  isMobileMenuOpen: boolean;
  exact?: boolean;
  isDisabled?: boolean;
}

export const AppSidebarLink: React.FC<AppSidebarlink> = props => {
  const {
    href,
    label,
    navIcon,
    isMobileMenuOpen,
    exact = true,
    isDisabled = false,
    ...rest
  } = props;
  const isActive = useActivePath(href, { end: exact });
  const isLarge = useBreakpointValue({ base: false, lg: true });

  const item = (
    <HStack gap={3.5}>
      <Icon as={navIcon} boxSize={4} />
      <Text
        whiteSpace='nowrap'
        noOfLines={1}
        hidden={!isMobileMenuOpen && isLarge}
      >
        {label}
      </Text>
    </HStack>
  );

  if (isDisabled) {
    return (
      <NavItem
        as='div'
        aria-disabled='true'
        aria-label={`${label}, coming soon`}
        cursor='not-allowed'
        opacity={0.2}
        pointerEvents='none'
        size='md'
        border='1px solid'
        borderColor='transparent'
        _hover={{
          bg: 'transparent',
          borderColor: 'transparent!',
          textDecoration: 'none',
        }}
        className='!my-0 [&:not(:last-child)]:!mb-px'
        {...rest}
      >
        {item}
      </NavItem>
    );
  }

  return (
    <NavItem
      as={Link}
      href={href}
      to={href}
      isActive={isActive}
      size='md'
      border='1px solid'
      borderColor='transparent'
      _hover={{
        bg: 'nav-item.bg-hover',
        borderColor: 'white.50!',
        textDecoration: 'none',
      }}
      _active={{
        bg: 'nav-item.bg-selected!',
        borderColor: 'white.50!',
      }}
      className='!my-0 [&:not(:last-child)]:!mb-px'
      {...rest}
    >
      {item}
    </NavItem>
  );
};
